import type { MaintenanceAlertStatus } from "@/lib/adminFleetApi";
import { ALERT_BADGE_CLASSES, ALERT_EMOJI, ALERT_LABELS } from "@/lib/fleetFormat";
import { cn } from "@/lib/utils";

/** Badge visual de situação de manutenção (🟢 Em dia / 🟡 Próxima / 🔴 Vencida). */
export function FleetAlertBadge({
  status,
  className,
}: {
  status: MaintenanceAlertStatus;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium",
        ALERT_BADGE_CLASSES[status],
        className,
      )}
    >
      <span aria-hidden>{ALERT_EMOJI[status]}</span>
      {ALERT_LABELS[status]}
    </span>
  );
}
